import { apiService } from '../../shared/services/apiService';
import { InbodyKeyInfo, InbodyKeyInfoFormValue } from '../interfaces/inbodyKey';

export type GetInbodyKeysResponse = { items: InbodyKeyInfo[] };
export type GetEntityInbodyKeysResponse = { inbodyKeys: InbodyKeyInfo[] };

export type DeleteInbodyKeyResponse = { status: string };

export const inbodyKeysService = {
  async getEntitiesBasics() {
    const resp = await apiService.get(`api/super/entities-basics`);

    return resp.data;
  },

  async getInbodyKeys() {
    const resp = await apiService.get<GetInbodyKeysResponse>('api/super/inbody-keys');

    return resp.data;
  },

  async getEntityInbodyKeys(entityId: number) {
    const resp = await apiService.get<GetEntityInbodyKeysResponse>(
      `api/entity/${entityId}/inbody-keys`,
    );

    return resp.data;
  },

  async addInbodyKey(data: InbodyKeyInfoFormValue) {
    const resp = await apiService.post<InbodyKeyInfo>('api/inbody-keys', data);

    return resp.data;
  },

  async updateInbodyKey(id: number, data: InbodyKeyInfoFormValue) {
    const resp = await apiService.put<InbodyKeyInfo>(`api/super/inbody-keys/${id}`, data);

    return resp.data;
  },

  async deleteInbodyKey(id: number) {
    const resp = await apiService.delete<DeleteInbodyKeyResponse>(
      `api/inbody-keys/${id}`,
    );

    return resp.data;
  },
};
